/* eslint-disable no-template-curly-in-string */
/**
 * @file 编辑器扩展, 增加自定义组件
 */
import { BasePlugin, registerEditorPlugin } from 'amis-editor'

export class InfoGridPlugin extends BasePlugin {
  // 关联渲染器名字
  rendererName = 'cham-rich-text';
  $schema = '/schemas/UnkownSchema.json';
  notRenderFormZone = true;
  // 组件名称（组件面板显示的Title）
  name = '自定义富文本';
  order = 0; // 排序
  description = '自定义富文本';
  tags = ['数据容器', '富文本'];
  icon = 'fa fa-file-code-o';
  scaffold = {
    'type': 'input-rich-text',
    'label': '富文本',
    'name': 'detail',
    'vendor': 'tinymce',
    'id': 'u:80b56d4c2c14',
    'options': {
      'plugins': 'advlist,autolink,link,image,lists,charmap,preview,anchor,pagebreak,searchreplace,wordcount,visualblocks,visualchars,code,fullscreen,insertdatetime,media,nonbreaking,table,emoticons,template,help',
      'toolbar': 'undo redo formatselect bold italic backcolor alignleft aligncenter alignright alignjustify bullist numlist outdent indent removeformat help',
      'menubar': true,
      'relative_urls': false,
      'remove_script_host': false,
      'convert_urls': true
    },
    'receiver': {
      'url': "/common/local/file/amisUpload",
      'method': 'post',
      'requestAdaptor': '',
      'adaptor': '',
      'messages': {}
    }
  };
  previewSchema = {
    'type': 'input-rich-text',
    'label': '富文本',
    'name': 'detail',
    'vendor': 'tinymce',
    'id': 'u:80b56d4c2c14',
    'options': {
      'plugins': 'advlist,autolink,link,image,lists,charmap,preview,anchor,pagebreak,searchreplace,wordcount,visualblocks,visualchars,code,fullscreen,insertdatetime,media,nonbreaking,table,emoticons,template,help',
      'toolbar': 'undo redo formatselect bold italic backcolor alignleft aligncenter alignright alignjustify bullist numlist outdent indent removeformat help',
      'menubar': true,
      'relative_urls': false,
      'remove_script_host': false,
      'convert_urls': true
    },
    'receiver': {
      'url': "/common/local/file/amisUpload",
      'method': 'post',
      'requestAdaptor': '',
      'adaptor': '',
      'messages': {}
    }
  };

  // 容器类组件必需字段
  // regions = [
  //   {
  //     key: 'body',
  //     label: '内容区'
  //   }
  // ];

  panelTitle = '配置'; // 右侧属性面板Title

  panelControls = [ // 右侧属性面板配置项

  ];
}

registerEditorPlugin(InfoGridPlugin)
